import { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import ChipInput from 'material-ui-chip-input';
import clsx from 'clsx';
import { ErrorMessage } from 'formik';
import { useStyles } from '../../styles';

interface Props {
    value: string[];
    setFieldValue: (fieldName: string, value: string[]) => void;
}

const NftCollectionsField: FC<Props> = ({ value, setFieldValue }) => {
    const classes = useStyles();

    return (
        <Box className={clsx(classes.row)}>
            <Typography className={classes.label}>NFTs collections</Typography>
            <ChipInput
                newChipKeyCodes={[13, 32]}
                allowDuplicates={false}
                defaultValue={value}
                onChange={(nfts: string[]) => setFieldValue('nftCollections', nfts)}
                variant="outlined"
                InputProps={{
                    name: 'nftCollections',
                    className: classes.chipFieldInput,
                }}
                fullWidth
            />

            <p className={classes.errorText}>
                <ErrorMessage name="nftCollections" />
            </p>
        </Box>
    );
};

export default NftCollectionsField;
